import { App as AntdApp, ConfigProvider, theme } from "antd";
import es_ES from "antd/es/locale/es_ES";
import React, { lazy, Suspense, useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	checkToken,
	fetchUserProfile,
	loadInitialData,
} from "./actions/authActions";
import withClearCache from "./ClearCache";
import { THEME } from "./constants";
import { isUserAuthorized } from "./store/selectors";
import { setCookie } from "./utils";

const MainContainer = lazy(() => import("./containers/MainContainer"));
const AuthContainer = lazy(() => import("./containers/AuthContainer"));

const App = () => {
	const dispatch = useDispatch();

	const ClearCacheComponent = withClearCache(() => {
		return <></>;
	});

	const { auth } = useSelector(isUserAuthorized) || {};

	const fetchInitialData = useCallback(() => {
		dispatch(fetchUserProfile());
		dispatch(loadInitialData());
	}, [dispatch]);

	const checkPersistency = useCallback(() => {
		dispatch(checkToken());
	}, [dispatch]);

	useEffect(() => {
		auth ? fetchInitialData() : checkPersistency();
	}, [auth, fetchInitialData, checkPersistency]);

	// Tema siempre oscuro
	useEffect(() => {
		const enforceDark = async () => {
			await setCookie(THEME, false);
			dispatch({ type: THEME, payload: false });
		};
		enforceDark();
	}, [dispatch]);

	useEffect(() => {
		document.body.classList.add("dark-theme");
		return () => document.body.classList.remove("dark-theme");
	}, []);

	const primaryColor = useMemo(() => {
		return (
			getComputedStyle(document.documentElement)
				.getPropertyValue("--primary-color")
				.trim() || "#6366f1"
		);
	}, []);

	return (
		<Suspense>
			<ConfigProvider
				locale={es_ES}
				theme={{
					token: {
						borderRadius: 3,
						colorPrimary: primaryColor,
						colorTextDisabled: "rgba(255, 255, 255, 0.50)",
					},
					algorithm: theme.darkAlgorithm,
				}}
			>
				<AntdApp>
					<ClearCacheComponent />
					{auth ? <MainContainer /> : <AuthContainer />}
				</AntdApp>
			</ConfigProvider>
		</Suspense>
	);
};

export default App;
